import moment from "moment";
import { useCallback, useState } from "react";
import { Button, Form } from "reactstrap";
import BusyButton from "../../common/busy-button";
import DateRange from "../../common/date-range";
import { RefreshIcon, SearchIcon } from "../../common/icons";

const LogSearchForm = (props: {
  onSubmit: (startDate: string, endDate: string) => void,
  onReset?: () => void,
  searching?: boolean
}) => {
  const { onSubmit, onReset, searching } = props;

  const [valid, setValid] = useState(true);

  const today = moment(new Date()).format('YYYY-MM-DD');

  const [startDate, setStartDate] = useState<string>(today);
  const [endDate, setEndDate] = useState<string>(today);

  const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (valid) {
      onSubmit(startDate, endDate);
    }
  }, [startDate, endDate, valid]);

  const handleReset = () => {
    setStartDate(today);
    setEndDate(today);
    onReset?.();
  };

  return (
    <Form onSubmit={handleSubmit} onReset={handleReset}>
      <DateRange startDate={startDate} endDate={endDate}
        requireStartDate maxEndDate={today}
        onStartDateChange={setStartDate} onEndDateChange={setEndDate}
        onValidate={setValid} />

      <div className="oms-row">
        <BusyButton type="submit" color="primary" disabled={!valid}
          value="Search" busy={searching}>
          <SearchIcon />
        </BusyButton>

        <Button type="reset" color="secondary" disabled={searching}>
          <RefreshIcon /> Reset
        </Button>
      </div>
    </Form>
  );
};

export default LogSearchForm;
